import { useQuery } from "@tanstack/react-query";
import { Charge } from "../../models/Charge";
import { getCharges } from "../../repositories/ChargeRepository";

export const useChargesQuery = (refetchInterval: number) => {
  return useQuery({
    queryKey: ["charges"],
    queryFn: async ({ signal }) => {
      const resp = await getCharges(undefined, signal);
      if (resp.ok) {
        return (resp.data?.tables?.[0]?.rows ?? []) as Charge[];
      }
      throw new Error(resp.message);
    },
    refetchInterval: refetchInterval > 0 ? refetchInterval * 1000 : false,
  });
};
